const INDEX_ITEMS = [
  { title: '韩国动作片', count: '856部', icon: 'ri-sword-line', desc: '拳拳到肉的硬核动作大片' },
  { title: '日本动画电影', count: '1,204部', icon: 'ri-ancient-gate-line', desc: '经典与新番动画全收录' },
  { title: '日韩爱情片', count: '632部', icon: 'ri-heart-line', desc: '催泪纯爱，温暖治愈' },
  { title: '悬疑惊悚', count: '489部', icon: 'ri-ghost-line', desc: '层层反转，烧脑不断' },
  { title: '韩国历史剧', count: '315部', icon: 'ri-history-line', desc: '波澜壮阔的历史画卷' },
  { title: '日本恐怖片', count: '278部', icon: 'ri-skull-line', desc: '日式恐怖，细思极恐' },
  { title: '喜剧搞笑', count: '421部', icon: 'ri-emotion-laugh-line', desc: '笑到停不下来的欢乐' },
  { title: '科幻奇幻', count: '356部', icon: 'ri-rocket-line', desc: '脑洞大开的想象世界' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">分类索引</h2>
        <p className="text-sm text-foreground-500 mb-8">按题材分类浏览，快速找到你想看的日韩电影</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.title}
              href={`#${item.title}`}
              className="flex items-start gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70 cursor-pointer no-underline hover:border-primary-200 hover:bg-primary-50/50 transition-colors group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">{item.desc}</p>
                <span className="text-[10px] text-foreground-400 mt-1 inline-block">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}